
import React from 'react';
import styled from 'styled-components/macro';

import HeaderMonarchController from 'screens/Studio/Studio/components/HeaderMonarch';
import PrePurchaseMainAppBarB from 'screens/App/components/PrePurchaseMainAppBarB';
import warehouse from 'services/warehouse';
import { TALKABLE_CONTAINER_Z_INDEX } from 'web-ui-kit/zIndexes';
import { MQ_FOR_MOBILE_BELOW } from 'web-ui-kit/media';
import { NAV_BAR_HEIGHT_MOBILE, NAV_BAR_HEIGHT_DESKTOP } from 'shared/components/NavigationBar';

// this component is used for both the Advocate landing page and the dashboard
// but they must be at exact paths.
// by default the advocate landing page must be at www.your-site.com/share
// and the dashboard must be at www.your-site.com/referrals
// these paths can be customized at https://www.admin.talkable.com/sites/modsy/placements

export default class TalkableDiv extends React.Component {
  _isMounted = false;

  state = { spaces: [] };

  setStateAsync (state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);

      this._isMounted = true;
    });
  }

  componentWillUnmount () {
    this._isMounted = false;
  }

  async componentDidMount () {
    const { authData } = this.props;

    // request spaces for user
    if (authData && !authData.loading && authData.loggedIn && this._isMounted) {
      try {
        let data = await warehouse.getStudioSpaceListFor({userId: authData.userId});
        if (data && data.results) { this.setStateAsync({spaces: data.results}); }
      } catch (err) {
        console.log(err);
      }
    }
  }

  render () {
    const { authData } = this.props;
    const userLoggedIn = !!(authData && !authData.loading && authData.loggedIn);
    const userNotLoggedIn = !userLoggedIn;

    return (
      <React.Fragment>
        {userLoggedIn &&
          <Header className={'header-talkable'} />
        }

        {userNotLoggedIn && <PrePurchaseMainAppBarB />}

        <TalkableContainer>
          <div id='talkable-offer' />
        </TalkableContainer>
      </React.Fragment>
    );
  }
}

const Header = styled(HeaderMonarchController)`
  &.header-talkable {
    /* To keep header above talkable image */
    z-index: ${TALKABLE_CONTAINER_Z_INDEX + 1};
  }
`;

const TalkableContainer = styled.div`
  position: absolute;
  left: 0;
  top: ${NAV_BAR_HEIGHT_DESKTOP}px;
  ${MQ_FOR_MOBILE_BELOW} {
    top: ${NAV_BAR_HEIGHT_MOBILE}px;
  }
  z-index: ${TALKABLE_CONTAINER_Z_INDEX};
  width: 100vw;
  height: auto;
  background: #fff;
  overflow-y: scroll;
`;
